export default __webpack_public_path__ + "static/media/Shoes_2.49c2fe9a.png";